/*
 * @Author: your name
 * @Date: 2021-04-21 14:28:28
 * @LastEditTime: 2021-07-08 10:27:39
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \cloud_app\src\common\components\Confirm.js
 */
import { isMobile } from "utils/utils";
import { MessageBox } from "element-ui";
import { Dialog } from "vant";

const confirm = MessageBox.confirm;

function Confirm(params) {
  if (!isMobile()) {
    return confirm(params);
  }
  if (isMobile()) {
    return Dialog.confirm(params);
  }
}

export default Confirm;
